import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export interface MembershipParams {
  name: string;
  email: string;
  mobile: string;
  dob: string;
  street_address: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContextualService {
  public campaignData: any;

  constructor(


    private http: HttpClient,
  ) { }

  getCampaigns(params: any) {
    return this.http.get(environment.campaignPath + "campaigns/list", {
      params: params
    }).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  getCampaignGiftcardRedeeem(campaignId:any,redeemId:any) {

		return this.http.post(environment.campaignPath + `campaigns/`+campaignId+`/gift_card_redemption_options/`+ redeemId+`/redeem`,{}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
  getCampaignsFromDashboard(params: any) {
    return this.http.get(environment.campaignPath + "campaigns/list_v2", {
      params: params
    }).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  getCampaignById(params: any) {
    return this.http.get(environment.campaignPath + `campaigns/${params.id}/${params.qtype}`).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  //https://sandbox-api.poshvine.com/cas/v1/campaigns/047f8bbe-957e-4458-af21-f18df44de2d1/membership_redemption_options/e17f7f30-4b51-40bc-ad24-7123a2e15c15'
  getCampaignMerchantDetails(merchantId: string, campaignId: string, optionType: string) {
    return this.http.get(environment.campaignPath + `campaigns/${campaignId}/${optionType}/${merchantId}`).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  getGiftcardsInCart(id:string, isSpecialBundle = false) {
    let params = {};
    if (isSpecialBundle) {
      params = { bundle_id: id, special: true }
    } else {
      params = { campaign_id: id }
    }
    return this.http.get(environment.offerPathV2 + `/cart`,
    {
      params
    }).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  deleteFromCart(id:string, params: any) {
    return this.http.delete(environment.campaignPath + `campaigns/${id}/carts`, params).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  pushToCart(id: string, params: any) {
    return this.http.post(environment.campaignPath + `campaigns/${id}/carts/add_items`, params).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  clearCartItems(id: string,type='campaign_id') {
    return this.http.post(environment.offerPathV2 + `/cart/clear?${type}=${id}`, {}).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  claimOffer(campaignId: string,offerId: string) {
    return this.http.post(environment.campaignPath + `campaigns/${campaignId}/offer_redemption_options/${offerId}/redeem`, {}).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  claimMembership(campaignId: string,membershipId: string , params?: MembershipParams) {
    return this.http.post(environment.campaignPath + `campaigns/${campaignId}/membership_redemption_options/${membershipId}/redeem`, {...params}).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }


  // https://api-customer.poshvine.com/cas/v1/user_redemptions?campaign_ids=e0955050-7ce6-412a-8334-5713f50d7253
  getCampaignRedemptionsById(campaignId:any){
    return this.http.get(environment.campaignPath + `user_redemptions?campaign_ids=${campaignId}`).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }

  // getCampaigns(params: any) {
  //   return this.http.get(environment.campaignPath + "/campaigns", {
  //     params: params
  //   }).pipe(
  //     map(res => res || []),
  //     catchError(error => throwError(error))
  //   );
  // }

  // redeem(offer, params) {
  //   return this.http.post(environment.offerPathV2 + "offers/" + offer.id + "/redeem", {}).pipe(
  //     map(res => res || []),
  //     catchError(error => throwError(error))
  //   );
  // }



}
